/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertRosetteAltIcon24Regular = forwardRef('CertRosetteAltIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1.75a7.25 7.25 0 0 0-5 12.5v7.399a1.25 1.25 0 0 0 1.911 1.06L12 20.785l3.089 1.926A1.25 1.25 0 0 0 17 21.649V14.25a7.25 7.25 0 0 0-5-12.5ZM6.25 9a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0Zm9.25 6.35c-1.038.574-2.23.9-3.5.9a7.217 7.217 0 0 1-3.5-.9v5.848l2.839-1.77a1.25 1.25 0 0 1 1.322 0l2.839 1.77v-5.847Z" })));
});
